import ReactGA from 'react-ga';
export const sendGAEvent = (props, e ) => {
  ReactGA.event({
      category: props.category,
      action: props.action,
      label: props.href
    })
  }